import { inject, Injectable } from "@angular/core";
import { StorageService } from "../storage/storage.service";
import { Product, Products } from "../../constants";
import { StorageType } from "../../constants";

@Injectable({
  providedIn: "root",
})
export class InitService {
  readonly #STORAGE_KEY_PRODUCT: string = "productId";
  readonly #storageService = inject(StorageService);
  /**
   * Sets the product id under the 'productId' key in local storage.
   * @param productId {@link string} ex: "8" for dtz. the full list is in {@link Product}
   */
  setProductId(productId: string): void {
    if (productId && this.#isProductIdValid(productId)) {
      this.#storageService.setItem(this.#STORAGE_KEY_PRODUCT, productId, StorageType.Local);
    }
  }
  /**
   * Returns the product from the local storage that is under the key: 'productId'.
   * @returns {@link Product} or null if not exists
   */
  getProductFromLocalStorage(): Product | null {
    const productId: unknown | null = this.#storageService.getItem(this.#STORAGE_KEY_PRODUCT);
    switch (productId) {
      case Products.GENERAL:
        return Products.GENERAL;
      case Products.TESTDAF:
        return Products.TESTDAF;
      case Products.TESTAS:
        return Products.TESTAS;
      case Products.ONSET:
        return Products.ONSET;
      case Products.DUO:
        return Products.DUO;
      case Products.DIGITAL_TESTAS:
        return Products.DIGITAL_TESTAS;
      case Products.DTZ:
        return Products.DTZ;
      case Products.INL:
        return Products.INL;
      case Products.DMAT:
        return Products.DMAT;
      case Products.GJUDAF:
        return Products.GJUDAF;
      default:
        return null;
    }
  }

  #isProductIdValid(productId: string): boolean {
    return (
      productId === Products.GENERAL ||
      productId === Products.TESTDAF ||
      productId === Products.TESTAS ||
      productId === Products.ONSET ||
      productId === Products.DUO ||
      productId === Products.DIGITAL_TESTAS ||
      productId === Products.DTZ ||
      productId === Products.INL ||
      productId === Products.DMAT ||
      productId === Products.GJUDAF
    );
  }
}
